// Pathify
import { make } from 'vuex-pathify'
//const env = process.env.NODE_ENV || 'development';
// Data
const state = {
  titleloading: false,
  drawer: null,
  isReverse: false,
  menuid:1,
  drawerImage: true,
  mini: false,
  //apiUrl : (env === 'development' ? "http://localhost:52965/" : "http://localhost:52965/"),
  apiUrl : "",
  apiSUrl : "",
  apiCUrl : "",
  apiFUrl : "",
  beta: "",
  isMaintenance:"",
  slaApi:"",
  selectedfromdate:null,
  selectedtodate:null,
  selecteduserid: null,
  timetablefromdate: null,
  timetabletodate: null,
  performancefromdate: null,
  performancetodate: null,
  attendancefromdate: null,
  attendancetodate: null,
  calenderselecteddate : null,
  fromDashboard: null,
  //apiUrl: appConfig.apiUrl,
items: [
    
  ],
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
